import React, { useMemo, useState, useEffect } from "react";

import { useInventarioInicial } from "../../../../contexto/provider/InventarioInicialContext.js";

import TablaCambiosInventario from "./TablaCambiosInventario.js";
import TablaGenerica from "../../../../componentsUI/tablas/tablaGenerica.js";


export default function TablaInventarioInicial({ periodoId, rowsPerPage = 8 }) {
  const { inventarioInicial, actualizarCantidad } = useInventarioInicial();

  const [itemsSeleccionados, setItemsSeleccionados] = useState({});
  const [mensaje, setMensaje] = useState("");
  const [valoresEditados, setValoresEditados] = useState({});

  const cambiosPendientes = Object.values(itemsSeleccionados);

  // 🔹 Filtrar por periodo
  const inventarioFiltrado = useMemo(() => {
    if (!periodoId) return [];
    return inventarioInicial.filter(
      (item) => Number(item.periodo_id) === Number(periodoId),
    );
  }, [inventarioInicial, periodoId]);

  // 🔹 cambio input
  const handleChangeStock = (id, value) => {
    setValoresEditados((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  // 🔹 agregar cambio
  const handleAgregarCambio = (item) => {
    const nuevoStock = Number(valoresEditados[item.id_inventario]);
    console.log(
      "[Component vistaInventarioInicial.js] nuevo stock",
      nuevoStock,
    );
    if (
      isNaN(nuevoStock) ||
      nuevoStock < 0 ||
      nuevoStock === Number(item.stock_apertura)
    )
      return;

    setItemsSeleccionados((prev) => ({
      ...prev,
      [item.id_inventario]: {
        id_inventario: item.id_inventario,
        id_producto: item.id_producto,
        nombre: item.productos_precio?.nombre || "Sin nombre",
        stock_actual: item.stock_apertura,
        stock_nuevo: nuevoStock,
      },
    }));
  };

  // 🔹 aprobar cambios
  const handleAprobarCambios = async () => {
    if (cambiosPendientes.length === 0) return;

    try {
      const resultados = await Promise.all(
        cambiosPendientes.map(async (cambio) => {
          const res = await actualizarCantidad({
            idInventario: cambio.id_inventario,
            cantidad: cambio.stock_nuevo,
          });

          return { nombre: cambio.nombre, cantidad: cambio.stock_nuevo, res };
        }),
      );

      setMensaje({
        texto: `Se actualizaron ${resultados.length} productos. `,
        success: true,
      });

      setItemsSeleccionados({});
      setValoresEditados({});
    } catch (error) {
      setMensaje({
        texto: `Error al actualizar inventario: ${error.message}`,
        success: false,
      });
    }
  };
  useEffect(() => {
    if (!mensaje) return;

    const timer = setTimeout(() => {
      setMensaje(null);
    }, 4000);

    return () => clearTimeout(timer); // limpia el timeout si mensaje cambia antes
  }, [mensaje]);

  return (
    <div className="contenedor-tabla">
      <div>
        <p>Elementos cargados: {inventarioFiltrado.length}</p>
      </div>

      {mensaje && (
        <div className={`mensaje ${mensaje.success ? "success" : "error"}`}>
          {mensaje.texto}
        </div>
      )}
      <TablaGenerica
        titulo="Control de Cambios"
        headers={["Producto", "Min", "Nuevo Stock", "Accion"]}
        data={inventarioFiltrado} // toda la data filtrada
        rowsPerPage={10} // número de filas por página
        renderRow={(item) => (
          <tr
            key={item.id_inventario}
            className={
              itemsSeleccionados[item.id_inventario] ? "fila-seleccionada" : ""
            }
          >
            <td className="col-1">
              {item.id_producto} -{" "}
              {item.productos_precio?.nombre || "Sin nombre"}
            </td>
            <td className="col-2">{item.stock_apertura}</td>
            <td className="col-3">
              <input
                type="number"
                min="0"
                value={
                  valoresEditados[item.id_inventario] ?? item.stock_apertura
                }
                onChange={(e) =>
                  handleChangeStock(item.id_inventario, e.target.value)
                }
                className="input-stock"
              />
            </td>
            <td className="col-4">
              <button
                className="btn-accion"
                onClick={() => handleAgregarCambio(item)}
                disabled={
                  valoresEditados[item.id_inventario] === undefined ||
                  Number(valoresEditados[item.id_inventario]) ===
                    Number(item.stock_apertura)
                }
              >
                Modificar
              </button>
            </td>
          </tr>
        )}
      />
      <div>
        <TablaCambiosInventario
          cambiosPendientes={cambiosPendientes}
          onQuitarCambio={(id) =>
            setItemsSeleccionados((prev) => {
              const copia = { ...prev };
              delete copia[id];
              return copia;
            })
          }
          onAprobarCambios={handleAprobarCambios}
        />
      </div>
    </div>
  );
}
